var map = {
	"./arrow-base.png": "9350",
	"./arrow-silver.png": "5f27",
	"./arrow.png": "c5d4",
	"./border.png": "715e",
	"./center-silver.png": "0a67",
	"./center.png": "6415",
	"./dark.png": "03aa",
	"./earth.png": "d2c9",
	"./fire.png": "3de4",
	"./fonts/matrix-book.ttf": "8b68",
	"./light.png": "b448",
	"./logo.png": "cf05",
	"./spellcaster.png": "3a16",
	"./types.png": "67a1",
	"./water.png": "b2c3",
	"./wind.png": "1e68"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";